module.exports = __webpack_public_path__ + "static/img/xiazaijietu2.04b900a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiazaijietu2.png
// module id = m05d
// module chunks = 24